import { render, staticRenderFns } from "./PaymentReservedMealCard.vue?vue&type=template&id=929fb79e&scoped=true"
import script from "./PaymentReservedMealCard.vue?vue&type=script&lang=js"
export * from "./PaymentReservedMealCard.vue?vue&type=script&lang=js"
import style0 from "./PaymentReservedMealCard.vue?vue&type=style&index=0&id=929fb79e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "929fb79e",
  null
  
)

export default component.exports